import { useTranslation } from "react-i18next";
import { useState } from "react";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import {
  CheckBoxSelection,
  Inject,
  MultiSelectComponent,
  DropDownListComponent,
} from "@syncfusion/ej2-react-dropdowns";
import css from "./index.module.css";
import ButtonComponent from "../../../cubeComponent/form/ButtonComponent";

function AttachIssues({ wrapperStyles = {}, handleSetOpenAttachIssuesModal, onSuccess }) {
  const { t } = useTranslation();
  const [selectedRadioOption, setSelectedRadioOption] = useState("attach_issues");
  const [selectedVersionType, setSelectedVersionType] = useState("current_version");
  const [selectedIssueType, setSelectedIssueType] = useState(["open", "in_review"]);

  const fileVersionsDataSource = [
    { id: "current_version", text: "Current version" },
    { id: "previous_version", text: "Previous versions except current" },
    { id: "all", text: "All previous versions including current" },
  ];

  const issueStatusesDataSource = [
    { id: "open", text: "Open" },
    { id: "in_review", text: "In review" },
    { id: "closed", text: "Closed" },
  ];

  const handleConfirmButtonClick = () => {
    onSuccess({
      selectedVersionType,
      selectedIssueType,
    });
    handleSetOpenAttachIssuesModal(false);
  };

  const handleCancelButtonClick = () => {
    handleSetOpenAttachIssuesModal(false);
  };

  const handleRadioOptionChange = (args) => {
    if (args.value == "no_issues") {
      setSelectedVersionType("");
      setSelectedIssueType([]);
    }
    setSelectedRadioOption(args.value);
  };

  const handleVersionTypeChange = (args) => {
    setSelectedVersionType(args.target.value);
  };

  const handleIssueTypeChange = (args) => {
    setSelectedIssueType(args.value);
  };

  return (
    <div className={`${css.fileManagerModalOverlayWrapper} ${wrapperStyles.fileManagerModalOverlayWrapper}`}>
      <div className={css.fileManagerModalWrapper}>
        <div className={css.headingWrapper}>
          <div className={css.heading}>{t("Attach Issues")}</div>
          <span className={css.crossIcon} onClick={handleCancelButtonClick}>
            &#10005;
          </span>
        </div>
        <div>The file(s) that you have selected contain(s) issue(s)</div>
        <div>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <RadioButtonComponent
              change={handleRadioOptionChange}
              checked={selectedRadioOption == "attach_issues"}
              value="attach_issues"
              label="Attach issues"
              name="issues_option"
            />
          </div>
          <div className={css.issuesOptions}>
            <div className={`${css.dropDownOptions} ${css.fileVersionDropDown}`}>
              <span>{t("File Version")}</span>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <DropDownListComponent
                  onChange={handleVersionTypeChange}
                  value={selectedVersionType}
                  fields={{ text: "text", value: "id" }}
                  dataSource={fileVersionsDataSource}
                  placeholder={t("Select type")}
                />
              </div>
            </div>
            <div className={`${css.dropDownOptions} ${css.statusDropDown}`}>
              <span>{t("Issue Status")}</span>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <MultiSelectComponent
                  value={selectedIssueType}
                  dataSource={issueStatusesDataSource}
                  fields={{ text: "text", value: "id" }}
                  placeholder={t("All status")}
                  mode="CheckBox"
                  change={handleIssueTypeChange}
                >
                  <Inject services={[CheckBoxSelection]} />
                </MultiSelectComponent>
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <RadioButtonComponent
            checked={selectedRadioOption == "no_issues"}
            value="no_issues"
            change={handleRadioOptionChange}
            label="Don't attach issues"
            name="issues_option"
          />
        </div>
        <div
          className={css.footerButtons}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ButtonComponent buttonType="gradientButton" onClick={handleConfirmButtonClick} cssClass="e-info">
            Confirm
          </ButtonComponent>
          <ButtonComponent onClick={handleCancelButtonClick} cssClass={`e-flat ${css.buttonLight}`}>
            Cancel
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

export default AttachIssues;
